import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './landing/LandingPage';
import DownloadPage from './landing/DownloadPage';
import './App.css';

// Ostatné routy lazy — landing (hlavná stránka) sa načíta bez ich kódu
const MobileAppRedirect = lazy(() => import('./components/MobileAppRedirect'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const NotFound = lazy(() => import('./components/NotFound'));
const Formatter = lazy(() => import('./components/Formatter'));
const QRFormatter = lazy(() => import('./components/QRFormatter'));
const InvoiceFormatter = lazy(() => import('./components/InvoiceFormatter'));
const TripCountdown = lazy(() => import('./components/TripCountdown'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const Support = lazy(() => import('./components/Support'));
const ObchodnePodmienky = lazy(() => import('./legal/ObchodnePodmienky'));
const Subdodavatelia = lazy(() => import('./legal/Subdodavatelia'));
const BusinessCard = lazy(() => import('./components/BusinessCard'));
const BusinessCardQR = lazy(() => import('./components/BusinessCardQR'));
const Recap2025 = lazy(() => import('./components/Recap2025/Recap2025'));
const ReportInfourad = lazy(() => import('./components/ReportInfourad'));
// Rezervácie (fáza 1, 5. 11. 2026) — verejné stránky pre klientov firiem
const BookingPage = lazy(() => import('./booking/BookingPage'));
const BookingTypePage = lazy(() => import('./booking/BookingTypePage'));
const BookingManage = lazy(() => import('./booking/BookingManage'));

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={null}>
          <Routes>
            <Route path="/formatter" element={<Formatter />} />
            <Route path="/qr-formatter" element={<QRFormatter />} />
            <Route path="/invoice-formatter" element={<InvoiceFormatter />} />
            <Route path="/report-infourad" element={<ReportInfourad />} />
            <Route path="/mobile-app/*" element={<MobileAppRedirect />} />
            <Route path="/business-card/:uuid" element={<BusinessCard />} />
            <Route path="/business-card-qr/:uuid" element={<BusinessCardQR />} />
            <Route path="/recap-2025/:uuid" element={<Recap2025 />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/obchodne-podmienky" element={<ObchodnePodmienky />} />
            <Route path="/vop" element={<ObchodnePodmienky />} />
            <Route path="/subdodavatelia" element={<Subdodavatelia />} />
            <Route path="/support" element={<Support />} />
            <Route path="/vianoce" element={<TripCountdown />} />
            <Route path="/r/manage/:token" element={<BookingManage />} />
            <Route path="/r/:page/:type" element={<BookingTypePage />} />
            <Route path="/r/:page" element={<BookingPage />} />
            <Route path="/download" element={<DownloadPage lang="SK" />} />
            <Route path="/cz/download" element={<DownloadPage lang="CZ" />} />
            <Route path="/en/download" element={<DownloadPage lang="EN" />} />
            <Route path="/" element={<LandingPage lang="SK" />} />
            <Route path="/cz" element={<LandingPage lang="CZ" />} />
            <Route path="/en" element={<LandingPage lang="EN" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
